import React from 'react'

interface CustomLogoProps {
  className?: string
  size?: number
}

export const CustomLogo: React.FC<CustomLogoProps> = ({
  className = '',
  size = 120,
}) => {
  return (
    <div className={`${className}`} style={{ width: size, height: size }}>
      <img
        src="/lovable-uploads/1583b00a-8c44-44f1-8948-c065a3407f49.png"
        alt="Mydra Logo"
        className="h-full w-full object-contain"
      />
    </div>
  )
}
